/// Store local data in user's browser

import {Dexie, Table} from "./dexie.min.js";

export class AnimeDB{
    public id: number = 0;
    public url: string = "";
    public show_view_order: boolean = false;
    /*Episode watched - VideoId -> EndTime*/
    protected watched_ep: {[k: number]: AnimeWatchData} = {};


    public constructor() {
    }
    static createDefault(id: number, url: string){
        const ans = new AnimeDB();
        ans.id = id;
        ans.url = url;
        return ans;
    }
    public setEpWatched(id: number, data: AnimeWatchData){
        if(!this.watched_ep) this.watched_ep={};
        this.watched_ep[id] = data;
        return this;
    }

    /**
     * Get episode watched for current anime
     */
    public get epWatched(): Map<number, AnimeWatchData>{
        const ans = new Map<number, AnimeWatchData>();
        for(let key in this.watched_ep)
            ans.set(+key, this.watched_ep[key]);
        return ans;
    }
    public removeEpWatched(id: number){
        delete this.watched_ep[id];
        return this;
    }
    public update(): Promise<any>{
        return DataStore.updateAnimeFull(this);
    }
}
interface AnimeWatchData{
    date: number;
    time: number;
}

class LocalDatabase extends Dexie {
    private animes!: Table<AnimeDB>;

    constructor() {
        super('YummyDB');
        this.version(1).stores({
            animes: '++_id,id,url'
        });
        this.animes.mapToClass(AnimeDB);
    }
    public getAnimeById(id: number): Promise<AnimeDB|undefined>{
        return this.animes.where('id').equals(id).first();
    }
    public getAnimeByUrl(url: string): Promise<AnimeDB|undefined>{
        return this.animes.where('url').equals(url).first();
    }
    public async insertAnime(anime: AnimeDB): Promise<AnimeDB>{
        if(!await this.getAnimeById(anime.id))
            await this.animes.add(anime);
        return anime;
    }
    public updateAnimeKey(animeId: number, k: keyof AnimeDB, value: any) : Promise<any> {
        return this.animes
            .where('id').equals(animeId)
            .modify({[k]: value});
    }
    public updateAnimeFull(anime: AnimeDB): Promise<any>{
        return this.animes
            .where('id').equals(anime.id)
            .modify(anime);
    }
    public async getAllVideos(): Promise<{videoId: number, time: number, date?: number}[]>{
        const animes = await this.animes.toArray();
        const ans=[];
        for(const anime of animes){
            for(const video of mapDB(anime))
                ans.push(video);
        }
        return ans;
        function *mapDB(anime: AnimeDB){
            for(const [videoId, obj] of anime.epWatched.entries())
                yield {
                    time: obj.time,
                    date: obj.date,
                    videoId: videoId
                };
        }
    }
}

export const DataStore = new LocalDatabase();
export async function onLoad(){
    if (page_type == 'anime') {
        const animeUrl = $("#anime_alias").attr('content')! as string;

        await DataStore.insertAnime(AnimeDB.createDefault(page_id!, animeUrl));
    }
}
//@ts-ignore
window.DataStore = DataStore